module.exports = __webpack_public_path__ + "static/media/2-5.4f5bc7d8.svg";